import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthorizationParams } from '@auth0/auth0-angular';
import { environment } from '@environments/environment';
import { SpinnerComponent } from '../../core/spinner/spinner.component';
import { AuthenticationService } from '../auth.service';

@Component({
  selector: 'app-auto-login',
  imports: [SpinnerComponent],
  templateUrl: './auto-login.component.html',
})
export class AutoLoginComponent implements OnInit {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly route = inject(ActivatedRoute);

  private readonly defaultDemoLinkConnection = 'DemoLink';
  private extractLoginHintFromUrl(): string | undefined {
    const resid = this.route.snapshot.paramMap.get('resid');
    const slug = this.route.snapshot.paramMap.get('slug');
    if (resid && slug) {
      return `${resid}/${slug}`;
    } else {
      return undefined;
    }
  }
  ngOnInit(): void {
    const loginHint = this.extractLoginHintFromUrl();
    const authParams: AuthorizationParams = {
      connection: environment.appConfiguration.demoLinkConnection ?? this.defaultDemoLinkConnection,
    };
    if (loginHint) {
      authParams.login_hint = loginHint;
    }
    this.authenticationService.login(authParams);
  }
}
